__turbopack_context__.v({
  "arrow": "articles-module__h8v8zW__arrow",
  "article": "articles-module__h8v8zW__article",
  "articleHeader": "articles-module__h8v8zW__articleHeader",
  "body": "articles-module__h8v8zW__body",
  "breadcrumb": "articles-module__h8v8zW__breadcrumb",
  "card": "articles-module__h8v8zW__card",
  "cardCopy": "articles-module__h8v8zW__cardCopy",
  "cardDate": "articles-module__h8v8zW__cardDate",
  "cardMeta": "articles-module__h8v8zW__cardMeta",
  "cards": "articles-module__h8v8zW__cards",
  "chartCaption": "articles-module__h8v8zW__chartCaption",
  "chartOverflowHint": "articles-module__h8v8zW__chartOverflowHint",
  "chartPlot": "articles-module__h8v8zW__chartPlot",
  "chartPlotScroll": "articles-module__h8v8zW__chartPlotScroll",
  "chartTheme": "articles-module__h8v8zW__chartTheme",
  "desktopNav": "articles-module__h8v8zW__desktopNav",
  "eyebrow": "articles-module__h8v8zW__eyebrow",
  "hero": "articles-module__h8v8zW__hero",
  "hub": "articles-module__h8v8zW__hub",
  "hubHeader": "articles-module__h8v8zW__hubHeader",
  "hubIntroduction": "articles-module__h8v8zW__hubIntroduction",
  "introduction": "articles-module__h8v8zW__introduction",
  "media": "articles-module__h8v8zW__media",
  "mediaImg": "articles-module__h8v8zW__mediaImg",
  "mediaWrap": "articles-module__h8v8zW__mediaWrap",
  "mobileNav": "articles-module__h8v8zW__mobileNav",
  "numeric": "articles-module__h8v8zW__numeric",
  "page": "articles-module__h8v8zW__page",
  "reading": "articles-module__h8v8zW__reading",
  "readingLayout": "articles-module__h8v8zW__readingLayout",
  "table": "articles-module__h8v8zW__table",
  "tableWrap": "articles-module__h8v8zW__tableWrap",
});
